import { createSelector } from 'reselect';

const ticketTypesData = (state) => state.ticketTypesData;

export const selectFilterData = () => createSelector([ticketTypesData], (state) => state.filter);

export const selectCreationFormData = () =>
  createSelector([ticketTypesData], (state) => state.creationForm);
